
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DOWNLOAD_CLIENT_TYPE } from '../constant';

@Component
export default class PcVideoSection extends Vue {
  @Prop({ default: () => require('@/assets/video/rj.mp4') }) videoSrc!: string;

  public downloadClientType = DOWNLOAD_CLIENT_TYPE;
}
